import React, { useCallback, memo } from 'react';
import { View, StyleSheet } from 'react-native';
import { rem, Spacer } from 'design-system';
import { useMainStackNavigation } from 'utils/types/navigationV6';
import { useAppSelector } from 'store/hooks';
import SectionHeader from './SectionHeader';
import StockFinancialInfoCard from './StockFinancialInfoCard';
import { abbreviateNumber, getMarginStr } from '../utils/format';
const StockFinancialSection = ({ assetId }) => {
    const { navigateDeprecated } = useMainStackNavigation();
    const financialInfoForSymbol = useAppSelector((state) => assetId ? state.stockInfoReducer.financials?.[assetId] : undefined);
    const handleSeeMore = useCallback(() => {
        if (assetId) {
            navigateDeprecated('InvestFinancial', { assetId });
        }
    }, [assetId]);
    if (!financialInfoForSymbol ||
        !financialInfoForSymbol.annual ||
        (!financialInfoForSymbol.annual.income?.length && !financialInfoForSymbol.annual.balanceSheet?.length)) {
        return null;
    }
    const incomeData = financialInfoForSymbol.annual.income?.[0];
    const balanceSheetData = financialInfoForSymbol.annual.balanceSheet?.[0];
    if (!incomeData && !balanceSheetData)
        return null;
    const maxYBalanceSheet = balanceSheetData
        ? Math.max(balanceSheetData.totalAssets, balanceSheetData.totalLiabilities)
        : 0;
    const maxYincomeData = incomeData ? Math.max(incomeData.totalRevenue, incomeData.netIncome) : 0;
    const netIncome = incomeData?.netIncome || 0;
    const totalRevenue = incomeData?.totalRevenue || 0;
    const totalAssets = balanceSheetData?.totalAssets || 0;
    const totalLiabilities = balanceSheetData?.totalLiabilities || 0;
    return (<View style={styles.container}>
      <SectionHeader title="Financials" onSeeMorePress={handleSeeMore}/>
      <View style={styles.cardsContainer}>
        {!!balanceSheetData && (<>
            <StockFinancialInfoCard title="Balance sheet" subTitle="Debt to assets" fiscalYear={String(balanceSheetData.fiscalYear)} leftBarPercent={(totalAssets / maxYBalanceSheet) * 100} titleMetrics={getMarginStr(totalAssets, totalLiabilities)} rightBarPercent={(totalLiabilities / maxYBalanceSheet) * 100} bottomLeftMetrics={{ metrics: abbreviateNumber(totalAssets), title: 'Assets' }} bottomRightMetrics={{ metrics: abbreviateNumber(totalLiabilities), title: 'Liabilities' }}/>
            <Spacer w={8}/>
          </>)}
        {!!incomeData && (<StockFinancialInfoCard title="Income statement" subTitle="Profit margin" fiscalYear={String(incomeData.fiscalYear)} titleMetrics={getMarginStr(totalRevenue, netIncome)} rightBarPercent={(netIncome / maxYincomeData) * 100} leftBarPercent={(totalRevenue / maxYincomeData) * 100} bottomLeftMetrics={{ metrics: abbreviateNumber(totalRevenue), title: 'Revenue' }} bottomRightMetrics={{ metrics: abbreviateNumber(netIncome), title: 'Net Income' }}/>)}
      </View>
    </View>);
};
export default memo(StockFinancialSection);
const styles = StyleSheet.create({
    container: {
        flex: 1,
    },
    cardsContainer: {
        flexDirection: 'row',
        paddingHorizontal: rem(16),
    },
});
